import React, { useState } from 'react'
import {
  Button,
  Modal,
  SelectAsync
} from '@arnsbogroup/react-voicearchive'
import useValidate, { is } from '@arnsbogroup/react-voicearchive/hooks/useValidate'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { useIntl } from 'react-intl'
import messages from './messages'
import debounce from 'debounce-promise'

export default NiceModal.create(({customer}) => {
  const modal = useModal()
  const [loading, setLoading] = useState(false)
  const [toBeMergedCustomer, setToBeMergedCustomer] = useState(null)
  const { formatMessage } = useIntl()

  if (!customer) {
    return null
  }

  const [validations, validate] = useValidate({toBeMergedCustomer: toBeMergedCustomer}, {
    toBeMergedCustomer: [is.present]
  })

  const i18n = (errorMessages) => errorMessages?.map((errorMessage) => ({
    present: formatMessage(messages.errorsPresent)
  }[errorMessage] || errorMessage))

  const mergeCustomer = () => {
    if (validate() && confirm(formatMessage(messages.disclaimer, {customerName: customer?.name, toBeMergedCustomerName: toBeMergedCustomer?.label}))) {
      setLoading(true)
      fetch(`/rest/v2/customer/${customer?.uid}/combine`, {
        credentials: "same-origin",
        method: "POST",
        body: JSON.stringify({toBeMergedCustomerId: toBeMergedCustomer?.value}),
      })
        .then((response) => response.json())
        .then(() => {
          toastr.success(formatMessage(messages.successToastr, {
            customerName: customer?.name,
            toBeMergedCustomerName: toBeMergedCustomer?.label
          }))
        })
        .finally(() => {
          setLoading(false)
          modal.resolve()
          modal.remove()
        })
    }
  }

  return (
    <Modal
      show={modal.visible}
      onClose={() => modal.remove()}
      onOutsideClick={() => modal.remove()}
      onSubmit={() => loading ? undefined : mergeCustomer()}
      title={`${formatMessage(messages.modalTitle)}`}
      dialogPanelClasses="max-w-xl overflow-x-scroll"
    >
      <div className="space-y-4">
        <SelectAsync
          required
          label={formatMessage(messages.selectCustomerLabel, {customerName: customer?.name})}
          description={formatMessage(
            messages.selectCustomerDescription,
            {
              customerName: customer?.name,
              toBeMergedCustomerName: toBeMergedCustomer
                ? toBeMergedCustomer?.label
                : formatMessage(messages.noCustomerSelected)
            }
          )}
          value={toBeMergedCustomer} 
          onChange={(customer) => { setToBeMergedCustomer(customer) }}
          cacheOptions
          loadOptions={ debounce((query) =>
            fetch(`/rest/v2/customer?search[name]=${query}`)
                .then((response) => response.json())
                .then(({data}) => data.map(({ uid, name }) => ({ label: name, value: +uid })))
            , 250)
          }
          openMenuOnFocus
          errors={i18n(validations.toBeMergedCustomer)}
        />
      </div>
      <div className='text-right mt-4'>
        <Button onClick={() => mergeCustomer()} disabled={loading}>
          {loading ? formatMessage(messages.loading) : formatMessage(messages.submit)}
        </Button>
      </div>
    </Modal>
  )
})
